import { FC } from 'react'

import { FlexContainer, Tooltip } from '@avantstay/backoffice-core'

import { parseLabel } from '@new/domains/operations/utils/parseLabel'

interface StringListPreviewFormatterProps {
  values?: string[]
}

const MAX_VALUES = 1

export const StringListPreviewFormatter: FC<StringListPreviewFormatterProps> = ({ values }) => {
  if (!values) return null
  const parsedText =
    values.length > MAX_VALUES ? `${values[0]}, + ${values.length - 1}` : values?.[0]

  return (
    <Tooltip
      content={
        <FlexContainer direction="column" alignItems="flex-start">
          {values.map(label => (
            <p key={label}>{parseLabel(label)}</p>
          ))}
        </FlexContainer>
      }
      disabled={values.length === 0}
    >
      <span>{parseLabel(parsedText)}</span>
    </Tooltip>
  )
}
